import { MarketplaceCode } from '@backmarket/http-api'
import { IconClock } from '@ds/icons/IconClock'
import { IconWarning } from '@ds/icons/IconWarning'

import translations from './TaxDetails.translations'
import type { LegalArea } from './TaxDetails.types'

export const FORM_ID = 'tax_details_form'

export const FORMATTED_VALUES = {
  VAT_MARGIN_SCHEME: {
    MARGIN_VAT: translations.marginVatFormattedValue,
    MIXED_VAT: translations.mixedVatFormattedValue,
    NORMAL_VAT: translations.normalVatFormattedValue,
  },
}

export const LEGAL_AREAS: Record<string, LegalArea> = {
  EU: MarketplaceCode.EU,
  NON_EU: 'NON_EU',
}

export const STATUS_COLORS = {
  FAILED_WRONG_NUMBER: 'danger',
  FAILED_WRONG_FORMAT: 'danger',
  PENDING: 'warning',
  VALIDATED: 'success',
}

export const STATUS_ICONS = {
  FAILED_WRONG_NUMBER: IconWarning,
  FAILED_WRONG_FORMAT: IconWarning,
  PENDING: IconClock,
}
